// extracted by mini-css-extract-plugin
export default {"body":"GenericDeleteModal_body__qrn0e"};